import { Organization } from "@situm/sdk-js";

/**
 * Message sending to webview 'container'
 * Does not send messages to current window's message listeners
 */
export const sendMessage = (type: string, payload?: unknown): void => {
  const message = makeMessage(type, payload);

  // nosemgrep: javascript.browser.security.wildcard-postmessage-configuration.wildcard-postmessage-configuration
  //@ts-expect-error
  window.webkit?.messageHandlers?.postListener?.postMessage(message); // iOS Needed

  const availableWebViews = ["SitumWebView", "ReactNativeWebView"];
  if (!availableWebViews.find((wv) => wv in window)) {
    // nosemgrep: javascript.browser.security.wildcard-postmessage-configuration.wildcard-postmessage-configuration
    window.parent.postMessage(message, "*");
    return;
  }
  availableWebViews.forEach((wv) => {
    if (wv in window) {
      //@ts-expect-error
      // nosemgrep: javascript.browser.security.wildcard-postmessage-configuration.wildcard-postmessage-configuration
      window[wv].postMessage(message);
    }
  });
};

const makeMessage = (type: string, payload?: unknown): string => {
  const msg: { type: string; payload?: unknown } = { type };
  payload && (msg.payload = payload);

  return JSON.stringify(msg);
};

/**
 * Verifies that the provided API key or JWT belongs to the currently selected
 * organization before accepting auth credentials via postmessage
 */
export const verifyOrganization = async ({
  domain,
  organizationId,
  apiKey,
  jwt,
}: {
  domain: string;
  organizationId: Organization["id"];
  apiKey?: string;
  jwt?: string;
}) => {
  try {
    const headers = apiKey
      ? { "X-API-Key": apiKey }
      : { Authorization: `Bearer ${jwt}` };

    const response = await fetch(
      `https://${domain}/api/v1/organizations/current_organization`,
      {
        headers,
      },
    );
    const data = (await response.json()) as Organization;

    if (data?.id !== organizationId) {
      console.error(
        "Rejected credentials: the provided credentials do not belong to the current organization",
      );
    }
  } catch (error) {
    console.error("Failed to verify credentials", error);
  }
};
